import Vue from 'vue'
import VueRouter from 'vue-router'
import api from '@/api'
import cookies from '@/libs/util.cookies'
import store from '@/store'

import util from '@/libs/util.js'
import { Toast } from 'vant'

// 路由数据
import routes from './routes'

Vue.use(VueRouter)

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  routes
})

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(async (to, from, next) => {
  // console.log('beforeeach', to, from)
  if (to.name === 'LoginError') {
    next()
  } else if (checkUser()) {
    // 有用户信息
    next()
  } else {
    Toast('正在登录中');
    // 用户信息不存在, 获取用户信息
    const appid = await getAppid()
    // code说明 ：code作为换取access_token的票据，每次用户授权带上的code将不一样，code只能使用一次，5分钟未被使用自动过期。
    let code = getQueryString("code");
    if (!code) {
      Toast.clear()
      // 重新获取静默授权
      getUserCode(appid)
      next(false)
    }
    if (code) {
      // 获取用户信息
      const userGet = await getUserInfo(code)
      Toast.clear()
      if (!userGet) {
        // 用户信息获取失效，跳转错误页面
        const info = {
          to: to.fullPath,
          from: from,
          location: util.deleteWechatInfo(window.location),
          appid: appid,
          code: code
        }
        next({
          name: 'LoginError',
          params: { info: JSON.stringify(info) }
        })
      } else {
        next()
      }
    }
  }
})

router.afterEach(to => {
  // console.log('afterEach', to)
  // 设置页面标题
  store.dispatch('history/pushHistory', to.name)
  util.title(to.meta.title)
})

// 获取cookie中的用户信息
function checkUser() {
  let uid = cookies.get('uid')
  let openid = cookies.get('openid')

  if (!uid || !openid) {
    return false
  } else {
    return true
  }
}

// 通过请求获取用户信息
async function getUserInfo(code) {
  // 获取用户信息
  let res = await api.WECHAT_OPENID({ code: code })
  if (res && res.user_id) {
    // 保留用户信息到cookie
    cookies.set('uid', res.user_id)
    cookies.set('openid', res.openid)
    return true
  } else {
    return false
  }
}

// 获取appid
async function getAppid() {
  let appid = cookies.get('appid')
  if (!appid) {
    appid = await api.WECHAT_APP_ID()
    cookies.set('appid', appid)
  }
  return appid
}

// 获取用户授权
function getUserCode(appid) {
  let redirectUrl = encodeURIComponent(util.deleteWechatInfo(window.location.href));
  let baseUrl = "https://open.weixin.qq.com/connect/oauth2/authorize";
  let state = "WnHRWxSTATE";
  let scope = "snsapi_base";
  const location = `${baseUrl}?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=${scope}&state=${state}&connect_redirect=1#wechat_redirect`;
  window.location.href = location
}

// 截取URL参数值
function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var code = decodeURIComponent(window.location.search)
    .substr(1)
    .match(reg);
  if (code != null) return decodeURI(code[2]);
  return null;
}

export default router
